webpackJsonp([1],[
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports) {

Config = {
    bucket: 'vuejs-photo-gallery'
};

module.exports = Config;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(34),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_AppHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_AppFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Thumbs__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Thumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Thumbs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Viewer__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cosmicjs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cosmicjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cosmicjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__event_bus__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//










var bucket = { slug: __WEBPACK_IMPORTED_MODULE_6__config__["bucket"] };

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components_AppFooter___default.a,
    AppHeader: __WEBPACK_IMPORTED_MODULE_0__components_AppHeader___default.a,
    Thumbs: __WEBPACK_IMPORTED_MODULE_2__components_Thumbs___default.a,
    Viewer: __WEBPACK_IMPORTED_MODULE_3__components_Viewer___default.a
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_5_cosmicjs___default.a.getObjectType({ bucket: bucket }, { type_slug: 'globals' }, function (err, res) {
      __WEBPACK_IMPORTED_MODULE_7__event_bus__["a" /* EventBus */].$emit('global_loaded', res.objects.all[0]);
      console.log(res.objects.all[0]);
    });
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(0);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-footer',
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$on('global_loaded', function (obj) {
            _this.text = obj.metafield.footer.value;
        });
    },
    data: function data() {
        return {
            text: null
        };
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app-header',
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$on('global_loaded', function (obj) {
            _this.header = obj.title;
            _this.text = obj.metafield.tagline.value;
            _this.twitter = obj.metafield.twitter.value;
            _this.instagram = obj.metafield.instagram.value;
            _this.github = obj.metafield.github.value;
            _this.email = 'mailto:' + obj.metafield.email.value;
        });
    },
    data: function data() {
        return {
            text: null,
            twitter: '',
            instagram: '',
            github: '',
            email: '',
            header: ''
        };
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cosmicjs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cosmicjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cosmicjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_bus__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//





var bucket = { slug: __WEBPACK_IMPORTED_MODULE_1__config__["bucket"] };

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'thumbs',
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0_cosmicjs___default.a.getObjectType({ bucket: bucket }, { type_slug: 'photos' }, function (err, res) {
            _this.items = res.objects.all;
            __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('loaded', _this.items[0]);
        });
        __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$on('move', function (dir) {
            _this.activeIndex = _this.activeIndex + dir;
            if (dir > 0 && _this.activeIndex >= _this.items.length) {
                _this.activeIndex = 0;
            }
            if (dir < 0 && _this.activeIndex < 0) {
                _this.activeIndex = _this.items.length - 1;
            }
            __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('loaded', _this.items[_this.activeIndex]);
        });
    },
    data: function data() {
        return {
            items: [],
            activeIndex: 0
        };
    },

    methods: {
        selectImage: function selectImage(itm, index) {
            __WEBPACK_IMPORTED_MODULE_2__event_bus__["a" /* EventBus */].$emit('loaded', itm);
            this.activeIndex = index;
        },
        decorateImgixUrl: function decorateImgixUrl(imgixUrl) {
            return imgixUrl + '?auto=format,compress&w=200&dpr=2';
        }
    }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus__ = __webpack_require__(0);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'viewer',
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$on('loaded', function (obj) {
            _this.img = obj;
        });
    },
    data: function data() {
        return {
            img: null
        };
    },

    methods: {
        selectNext: function selectNext() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('move', 1);
        },
        selectPrev: function selectPrev() {
            __WEBPACK_IMPORTED_MODULE_0__event_bus__["a" /* EventBus */].$emit('move', -1);
        }
    }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(35),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(33),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(31),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(32),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "thumbnails"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('article', {
      class: {
        'active': _vm.activeIndex == index
      }
    }, [_c('a', {
      staticClass: "thumbnail",
      on: {
        "click": function($event) {
          _vm.selectImage(item, index)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.decorateImgixUrl(item.metafield.image.imgix_url),
        "alt": ""
      }
    })]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }), 0)
},staticRenderFns: []}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "viewer"
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "nav-next",
    on: {
      "click": function($event) {
        _vm.selectNext()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-previous",
    on: {
      "click": function($event) {
        _vm.selectPrev()
      }
    }
  })]), _vm._v(" "), (_vm.img) ? _c('div', {
    staticClass: "slide active"
  }, [_c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v(_vm._s(_vm.img.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.img.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image",
    style: ({
      backgroundImage: "url(" + _vm.img.metafield.image.imgix_url + "?auto=format,compress&w=2000&q=75)",
      backgroundSize: "cover",
      backgroundPosition: "center"
    })
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    attrs: {
      "id": "header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "icons"
  }, [_c('li', [_c('a', {
    staticClass: "icon fa-twitter",
    attrs: {
      "href": _vm.twitter
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Twitter")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-instagram",
    attrs: {
      "href": _vm.instagram
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Instagram")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-github",
    attrs: {
      "href": _vm.github
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Github")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "icon fa-envelope-o",
    attrs: {
      "href": _vm.email
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("Email")])])])])])
},staticRenderFns: []}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('app-header'), _vm._v(" "), _c('thumbs'), _vm._v(" "), _c('app-footer')], 1), _vm._v(" "), _c('viewer')], 1)
},staticRenderFns: []}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[14]);


// WEBPACK FOOTER //
// static/js/app.c5797acad790a1df0573.js